import { FileInputData } from '@/types/asset';
import { pimCoreUrl } from './config';

export const getPimcoreFullPath = (relativePath?: string): string => {
  if (relativePath && !relativePath.includes('http')) {
    return `${pimCoreUrl}${relativePath}`;
  }
  return relativePath || '';
};

export const getFileContentFromBase64 = (fileBase64: string|ArrayBuffer|null): FileInputData|null => {
  if (typeof fileBase64 === 'string') {
    const regex = /data:(.*);base64,(.*)/;
    const match = fileBase64.match(regex);
    if (match) {
      const mimeType = match[1];
      const content = match[2];
      const type = mimeType.includes('image')
        ? 'image'
        : 'file';
      return {
        type,
        content,
      };
    }
  }
  return null;
};

export const convertFileToBase64 = (file: File): Promise<FileInputData|null> => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    const fileData = getFileContentFromBase64(reader.result);
    if (fileData) {
      resolve(fileData);
    } else {
      resolve(null);
    }
  };
  reader.onerror = (error) => reject(error);
});

export const parseCreateMessageId = (message: string): number => {
  if (message) {
    const idNumber = message.split(':')[1];
    return idNumber
      ? Number.parseInt(idNumber, 10)
      : 0;
  }
  return 0;
};
